import { render, staticRenderFns } from "./TraderInfoGroup.vue?vue&type=template&id=8aaea1b0&"
import script from "./TraderInfoGroup.vue?vue&type=script&lang=ts&"
export * from "./TraderInfoGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TraderInfoGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports